import React from 'react';

const Button = ({
   children,
   onClick,
   type = 'button',
   variant = 'primary',
   size = 'md',
   disabled = false,
   className = '',
   ...props
}) => {
   const baseClasses =
      'font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';

   const variantClasses = {
      primary:
         'bg-blue-600 dark:bg-dark-accent text-white hover:bg-blue-700 dark:hover:bg-cyan-500 focus:ring-blue-500 dark:focus:ring-dark-accent',
      secondary:
         'bg-gray-600 dark:bg-gray-700 text-white hover:bg-gray-700 dark:hover:bg-gray-600 focus:ring-gray-500',
      success:
         'bg-green-600 dark:bg-green-700 text-white hover:bg-green-700 dark:hover:bg-green-600 focus:ring-green-500',
      danger:
         'bg-red-600 dark:bg-red-700 text-white hover:bg-red-700 dark:hover:bg-red-600 focus:ring-red-500',
      info: 'bg-cyan-600 dark:bg-dark-accent text-white hover:bg-cyan-700 dark:hover:bg-cyan-500 focus:ring-cyan-500',
      outline:
         'border-2 border-blue-600 dark:border-dark-accent text-blue-600 dark:text-dark-accent hover:bg-blue-50 dark:hover:bg-dark-secondary focus:ring-blue-500 dark:focus:ring-dark-accent',
   };

   const sizeClasses = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg',
   };

   const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';

   return (
      <button
         type={type}
         onClick={onClick}
         disabled={disabled}
         className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`}
         {...props}
      >
         {children}
      </button>
   );
};

export default Button;
